import { relative } from "node:path";
import type { DriftIssue, ScaffoldFrontmatter } from "../../types.js";
import { parseFrontmatter } from "../frontmatter.js";
import { resolveDualRootPath } from "./_resolve-path.js";

/** Map absolute file paths to project-relative paths. */
const relativize = (files: readonly string[], root: string): string[] =>
  files.map((f) => relative(root, f));

/** Check that all YAML frontmatter edge targets exist for every scaffold file. */
export function checkEdgesAll(
  scaffoldFiles: string[],
  projectRoot: string,
  scaffoldRoot: string
): DriftIssue[] {
  const issues: DriftIssue[] = [];
  const sources = relativize(scaffoldFiles, projectRoot);
  for (let i = 0; i < scaffoldFiles.length; i++) {
    const filePath = scaffoldFiles[i];
    issues.push(
      ...checkEdges(parseFrontmatter(filePath), filePath, sources[i], projectRoot, scaffoldRoot)
    );
  }
  return issues;
}

/** Check that all YAML frontmatter edge targets exist */
export function checkEdges(
  frontmatter: ScaffoldFrontmatter | null,
  _filePath: string,
  source: string,
  projectRoot: string,
  scaffoldRoot: string
): DriftIssue[] {
  if (!frontmatter?.edges) return [];

  const issues: DriftIssue[] = [];

  for (const edge of frontmatter.edges) {
    if (!edge.target) continue;

    if (!resolveDualRootPath(edge.target, { projectRoot, scaffoldRoot })) {
      issues.push({
        code: "DEAD_EDGE",
        severity: "error",
        file: source,
        line: null,
        message: `Frontmatter edge target does not exist: ${edge.target}`,
      });
    }
  }

  return issues;
}
